import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';
import { nameResolver } from '@/_shared';

import { useGetContactsMutation } from '../apis';
import type { ContactQuerySchema } from '../schemas';

export function AsyncContactWithAllDetailsSelector({ disabled, ...props }: FormAsyncComboboxProps<ContactQuerySchema>) {
  const getName = useCallback(
    (item: ContactQuerySchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = nameResolver(item.first_name, item.last_name, '');

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/contacts/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => `${item.id}`}
      useApi={useGetContactsMutation}
      disabled={disabled}
    />
  );
}
